// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__uul_d","description":"PatientConsentPreview_description__30le8"};